export const GET_NOTIFICATION_RECIPIENTS = "notification/GET_RECIPIENTS";
export const CREATE_NOTIFICATION = "notification/CREATE";
export const GET_NOTIFICATION_HISTORY = "notification/GET_HISTORY";
